import { render, staticRenderFns } from "./WorkflowTestProcessAdd.vue?vue&type=template&id=24b53e44"
import script from "./WorkflowTestProcessAdd.vue?vue&type=script&lang=js"
export * from "./WorkflowTestProcessAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports